import { render, staticRenderFns } from "./unilevel.vue?vue&type=template&id=542644ec&scoped=true"
import script from "./unilevel.vue?vue&type=script&lang=js"
export * from "./unilevel.vue?vue&type=script&lang=js"
import style0 from "./unilevel.vue?vue&type=style&index=0&id=542644ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542644ec",
  null
  
)

export default component.exports